<template>
    <layout>
        <div class="bg-image bg-trees full-height" style="overflow: auto;">
            <div class="content content-boxed">
                <div class="row">
                    <div class="col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2">
                        <div class="block block-rounded animated fadeIn push-50-t" id="registration-container">
                            <div class="block-content block-content-full block-content-narrow">
                                <h1 class="h2 font-w600 push-20-t push-50">
                                    <img src="../../assets/img/logo-complete.png" height="58">
                                </h1>
                                <p>Please fill the following details to create a new forester account.</p>

                                <form v-on:submit.prevent="register" class="form-horizontal push-30-t push-30" novalidate="novalidate">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <wc-input label="First Name" v-model="first_name"></wc-input>
                                        </div>

                                        <div class="col-sm-6">
                                            <wc-input label="Last Name" v-model="last_name"></wc-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <wc-input type="email" label="Email" v-model="email"></wc-input>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-12">
                                            <wc-input type="password" label="Password" v-model="password"></wc-input>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-12">
                                            <wc-input type="password" label="Password Confirmation" v-model="password_confirmation"></wc-input>
                                        </div>
                                    </div>

                                     <!--
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="col-xs-12" for="phone">Phone <small class="text-muted">(optional)</small></label>
                                                <div class="col-xs-12">
                                                    <input class="form-control" type="wcphone" v-model="phone">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="col-xs-12" for="company">Company <small class="text-muted">(optional)</small></label>
                                                <div class="col-xs-12">
                                                    <input class="form-control" type="text" v-model="company">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="form-group">
                                                <label class="col-xs-12" for="address">Street Address</label>
                                                <div class="col-xs-12">
                                                    <input class="form-control" type="text" name="address">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="col-xs-12" for="city">City</label>
                                                <div class="col-xs-12">
                                                    <input class="form-control" type="text" name="city">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <label class="col-xs-12" for="State">State</label>
                                                <div class="col-xs-12">
                                                    <select class="form-control valid" name="province_id" required="" aria-required="true" aria-invalid="false" aria-describedby="province_id-error">
                                                        <option disabled="" selected=""></option>
                                                        <option value="1">ON</option>
                                                        <option value="2">QC</option>
                                                        <option value="3">NS</option>
                                                        <option value="4">NB</option>
                                                        <option value="5">MB</option>
                                                        <option value="6">BC</option>
                                                        <option value="7">PEI</option>
                                                        <option value="8">SK</option>
                                                        <option value="9">AB</option>
                                                        <option value="10">NL</option>
                                                        <option value="11">NT</option>
                                                        <option value="12">YT</option>
                                                        <option value="13">NU</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <label class="col-xs-12" for="postal_code">Zip Code</label>
                                                <div class="col-xs-12">
                                                    <input class="form-control" type="text" name="postal_code">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    -->
                                    <br>
                                    <div class="form-group">
                                        <div class="col-xs-12">
                                            <button class="btn btn-lg btn-block btn-primary" type="submit">
                                                Create Account
                                            </button>
                                        </div>
                                    </div>
                                    <!-- <p class="text-center remove-margin-b">Already have an account? <router-link to="login">Log In Now</router-link></p> -->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
    import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';

    export default {
        name: 'login',
        data () {
            return {
                email: '',
                password: '',
                password_confirmation: '',
                first_name: '',
                last_name: ''
            };
        },
        components: {
            layout: require('../layouts/blank.vue'),
            wcInput: require('../elements/forms/wc-input.vue')
        },
        methods: {
            register () {
                // Trigger validation
                this.$v.$touch();

                // Halt submission if credentials are invalid
                if (this.$v.$invalid) {
                    this.$toasted.error('Please complete all required fields.');
                    return;
                }

                // Send registration request to API
                this.axios.post('auth/register', this.$data)
                    .then((response) => {
                        this.$toasted.success('Registration successful! Please login.');
                        this.$router.push('login');
                    });
            }
        },
        validations: {
            email: { required, email },
            password: { required, minLength: minLength(6) },
            password_confirmation: { sameAsPassword: sameAs('password') },
            first_name: { required },
            last_name: { required }
        }
    };
</script>



// WEBPACK FOOTER //
// register.vue?9e6062a2